import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString
} from 'class-validator';
import { ParseLogDto } from './parser-log.dto';
import { UserDto } from '../user.dto';
import { PersonDto } from '../person.dto';

export enum Interval {
  ONE_MINUTE = '1__min',
  TEN_MINUTES = '10__min',
  THIRTY_MINUTES = '30__min',
  ONE_HOUR = '1__hour',
  ONE_DAY = '24__hour',
}

export enum SupportedProviders {
  YANDEX = 'YANDEX',
  GOOGLE = 'GOOGLE', // никто никогда не тестировал как это будет работать
}

export enum VerificationStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export class CreateEmailAccountDto {
    @IsNumber()
      userId: number;

    @IsNotEmpty()
    @IsString()
      email: string;
  
    @IsString()
      password: string;

    @IsEnum(SupportedProviders)
      provider: SupportedProviders;

    @IsEnum(Interval)
      checkInterval: Interval;

    @IsBoolean()
      active: boolean;

    @IsBoolean()
      general: boolean;

    @IsOptional()
    @IsString()
      status?: string;

    @IsOptional()
    @IsNumber()
      messageCount?: number;
}
  
export class EmailAccountDto extends CreateEmailAccountDto {
    @IsNumber()
      id: number;

    @Type(() => PersonDto)
      user: PersonDto;
}

export class EmailAccountLogParserDto extends CreateEmailAccountDto {
    @IsNumber()
      id: number;
    
    @Type(() => UserDto)
      user: UserDto;

    @Type(() => ParseLogDto)
      logs: ParseLogDto[];
}

export class EmailMessageRelationDto {
    id: number;
    name: string;
}

export class EmailMessageLeadDto {
    id: number;
    subject: string;
}

export class EmailMessageListItemDto {
    id: number;
    messageIdCRC32: string;
    subject: string;
    from: string;
    type: string;
    date: Date;
    lead?: EmailMessageLeadDto;
    clients: EmailMessageRelationDto[];
}

export class EmailSpamListItemDto {
    id: number;
    email: string;
    createdAt: Date;
    lead?: EmailMessageLeadDto;
}

export declare class UpdateEmailAccountDto {
    @IsNumber()
      id: number;

    @IsNumber()
      userId: number;

    @IsNotEmpty()
    @IsString()
      email: string;
  
    @IsString()
      password: string;

    @IsEnum(SupportedProviders)
      provider: SupportedProviders;

    @IsEnum(Interval)
      checkInterval: Interval;
    
    @IsBoolean()
      active: boolean;

    @IsBoolean()
      general: boolean;
}
